import Vue from 'vue';
import Vuex from 'vuex';
import { DeepReadonly } from 'ts-essentials';
import { stateTv, mutationsTv, actionsTv } from './tvGuide';
import { stateNav, mutationsNav, actionsNav } from './navigation';
import { stateOthers, mutationsOthers, actionsOthers } from './others';
import { Dispatch } from './types';
import {
  mapState as mapStateVuex,
} from 'vuex';

Vue.use(Vuex);

const stateStore = { ...stateTv, ...stateNav, ...stateOthers };

const store = {
  state: stateStore,

  mutations: { ...mutationsTv, ...mutationsNav, ...mutationsOthers },

  actions: { ...actionsTv, ...actionsNav, ...actionsOthers },

  getters: {},
};

export default store as Store;
export const vuexStore = new Vuex.Store(store);

export type State = typeof stateStore;
export type Store = typeof store & { state: DeepReadonly<State> };

export function mapState<T extends keyof Store['state']>(state: T[]): { [K in T]: () => State[K] } {
  return mapStateVuex(state) as any;
}

export const dispatch: Dispatch = async (mutation, payload) => {
  return vuexStore.dispatch(mutation, payload);
};
